module.exports = __webpack_public_path__ + "2abd3d999f69d61d83bcf9ce727f338c.svg";